import produce from 'immer';
import { ProductionProductGroup } from '~/domain/model';
import { createCreator, createReducer, Reducer } from '~/helpers/util/reducers';

export type Status = 'cleared' | 'updated';

export type ProductionProductGroupState = {
  productionProductGroupById: Map<string, ProductionProductGroup>;
  status: Status;
};

export type Update = {
  productionProductGroupById: Map<string, ProductionProductGroup>;
};

const prefix = '@productionProductGroup';

export const Types = Object.freeze({
  CLEAR: `${prefix}/CLEAR`,
  UPDATE: `${prefix}/UPDATE`
});

export const initialState: ProductionProductGroupState = {
  productionProductGroupById: new Map(),
  status: 'cleared'
};

const clearReducer: Reducer<ProductionProductGroupState, void> = state => {
  return produce(state, draft => {
    draft.productionProductGroupById = initialState.productionProductGroupById;
    draft.status = initialState.status;
  });
};

const updateReducer: Reducer<ProductionProductGroupState, Update> = (
  state,
  action
) => {
  return produce(state, draft => {
    draft.productionProductGroupById = action.productionProductGroupById as Map<
      string,
      ProductionProductGroup
    >;
  });
};

export const actions = Object.freeze({
  clear: createCreator<void>(Types.CLEAR),
  update: createCreator<Update>(Types.UPDATE)
});

export const reducer = createReducer(initialState, {
  [Types.CLEAR]: clearReducer,
  [Types.UPDATE]: updateReducer
});
